export default __webpack_public_path__ + "static/media/swedgo-screenshot-02.db098324.png";